import { create } from "zustand";

export const authModalStore = create((set) => ({
  open: false,
  handleOpen: () => set({ open: true }),
  handleClose: () => set({ open: false }),
}));
